module.exports = __webpack_public_path__ + "static/media/arrow.0707cc71.svg";